<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据库</el-breadcrumb-item>
      <el-breadcrumb-item>历史订单列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-tabs v-model="tabIndex" @tab-click="handleClick">
        <el-tab-pane v-for="item in statusOptions" :key="item.id" :label="item.value"></el-tab-pane>
      </el-tabs>

      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入订单号" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <el-input placeholder="请输入经销商" v-model="queryInfo.agencyName" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>

        
        <el-col :span="8">
          <div class="block aaaa">
            下单时间：
            <el-date-picker v-model="queryInfo.time" @change="timechange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            发货时间：
            <el-date-picker v-model="queryInfo.send_at" @change="timechange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </div>
        </el-col>

        <el-col :span="5">
          <el-input placeholder="请输入商品编码" v-model="queryInfo.number" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>

        <el-col :span="4" v-if="canLook == 1 && tabIndex != 5">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time) + '&status=' + queryInfo.status+ '&query=' + queryInfo.query + '&agencyName=' 
          + queryInfo.agencyName + '&number=' + queryInfo.number + '&send_at='+JSON.stringify(queryInfo.send_at)+'&tid='+queryInfo.tid">
            <el-button size="mini" type="info">导出订单</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 style="width: 100%"-->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" @filter-change="handleFilterChange" @selection-change="handleSelectionChange">
        <!-- 展开列 -->
        <el-table-column type="index"></el-table-column>

        <el-table-column label="商品信息" type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.goods_info" border stripe ref="xxxTable" tooltip-effect="dark">
              <el-table-column label="商品名称" align="center" prop="goodinfo.title" width="180px"> </el-table-column>
              <el-table-column label="商品编号" prop="goodinfo.number" width="70px"> </el-table-column>

              <el-table-column label="商品规格" prop="goodinfo.preNum" width="70px"> </el-table-column>
            <el-table-column label="商品单价" prop="goodinfo.price" align="center" width="70px"> </el-table-column>
              <el-table-column label="参与活动" prop="goodinfo.activityContent" align="center" width="120px"> </el-table-column>

              <el-table-column label="预定下周订单截止时间" prop="goodinfo.g_endTime" align="center" width="150px" v-if="scope.row.good_type == 2"> </el-table-column>
              <el-table-column label="是否已确定商品" prop="goodinfo.statusTxt" align="center" width="120px" v-if="scope.row.good_type == 2"> </el-table-column>
              <el-table-column label="下周/下下周" prop="goodinfo.week" align="center" width="130px" v-if="scope.row.good_type == 2"> </el-table-column>
               <el-table-column label="购买数量" prop="goodinfo.buyNum" width="70px"> </el-table-column>
              <el-table-column label="赠送数量" prop="goodinfo.sendNumber" width="70px"> </el-table-column>
              <el-table-column label="件数小计" prop="goodinfo.goodTotalNum" width="70px"> </el-table-column>
             </el-table>
          </template>
        </el-table-column>

        <el-table-column type="selection" width="55" fixed> </el-table-column>
        <el-table-column label="订单编号" prop="order_id" width="130px"></el-table-column>
        <!-- <el-table-column :label="typeTxt" align="center" :filter-multiple="false" :column-key="'type'" :filters="filterStatus" prop="type" width="100px"> </el-table-column> -->
        <el-table-column align="center" width="150px" :key="Math.random()">
          <template slot="header" slot-scope="scope">
            <el-select v-model="typeValue" size="mini" @change="changeType" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type == '常温商品'">常温商品</el-tag>
            <el-tag class="info" v-if="scope.row.type == '低温商品'">低温商品</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="下单经销商" prop="agencyName" width="120px" :key="Math.random()"></el-table-column>
        <el-table-column label="总价" prop="order_amount_total" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="余额" prop="payWithMoney" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="授信" prop="payWithCredit" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="返点" prop="payWithRefund" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="设备补贴" prop="payWithSubsidy" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="总数量" prop="totalNum" align="center" width="60px" :key="Math.random()"> </el-table-column>
        <el-table-column label="区域" v-if="tabIndex == 3 || tabIndex == 2 || tabIndex == 4" prop="buType" align="center" width="60px" :key="Math.random()"> </el-table-column>
       <el-table-column label="取消原因" v-if="tabIndex == 5" prop="cancel_reason" align="center" width="100px" :key="Math.random()"> </el-table-column>
        <el-table-column label="状态" prop="order_status" width="100px">
          <!-- 全部-1 待支付0 待确认1 ,待发货2,已发货3 ,已完成4, 退款5 取消6 -->
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.order_status == '0'">未付款</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.order_status == '1'">待确认</el-tag>
            <el-tag class="daifahuo" v-if="scope.row.order_status == '2'">待发货</el-tag>
            <el-tag class="yifahuo" v-if="scope.row.order_status == '3'">已发货</el-tag>
            <el-tag type="success" v-if="scope.row.order_status == '4'">已完成</el-tag>
            <el-tag type="danger" v-if="scope.row.order_status == '5' && scope.row.tuikuanStatus == '0'">退款中，待确认</el-tag>
            <el-tag type="danger" v-if="scope.row.order_status == '5' && scope.row.tuikuanStatus == '1'">退款成功</el-tag>
            <el-tag type="info" v-if="scope.row.order_status == '6'">已取消</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="收货地址" prop="addressDetail" width="420px" :key="Math.random()"></el-table-column>
        <el-table-column label="下单时间" prop="create_at">
          <template slot-scope="scope">
            {{ scope.row.create_at | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column label="发货时间" prop="create_at">
          <template slot-scope="scope">
            {{ scope.row.send_at | scope.row.send_at!=='无'?dateFormat:'无' }}
          </template>
        </el-table-column>
        
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      
      v-if="!queryInfo.number">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      canLook: 1,
      // exportUrl: 'http://huangshi-localhost/exportHistoryOrderExcel?mPhone=' + localStorage.getItem('phone'), 
      exportUrl: 'https://hsznttghpt.hsxsn.cn/exportHistoryOrderExcel?mPhone=' + localStorage.getItem('phone'), 
      queryInfo: {
        query: '',
        agencyName: '',
        time: null,
        status: -1,
        type: 0,
        tid: 0,
        number: null,
        pagenum: 1,
        pagesize: 10,
        send_at:null
      },

      statusValue: '全部',
      statusOptions: [
        { value: '全部', id: -1 },
        // { value: '未付款', id: 0 },
        { value: '待确认', id: 1 },
        { value: '待发货', id: 2 },
        { value: '已发货', id: 3 },
        { value: '已完成', id: 4 },
        // { value: '退款', id: 5 },
        { value: '已取消', id: 6 },
      ],
      typeTxt: "商品类型",
      filterStatus: [
        { text: '常温产品', value: 1 },
        { text: '低温产品', value: 2 }],

      typeValue: '商品类型',
      options: [
        { label: '商品类型', value: 0 },
        { label: '常温商品', value: 1 },
        { label: '低温商品', value: 2 },
      ],
      total: 0,
      orderlist: [],
      sendVisible: false,
      sendForm: {
        sendName: null,
        sendPhone: null
      },

      sureOrderDialogVisible: false,
      buTypeForm: {
        buType: true
      },

      progressVisible: false,
      progressInfo: [],
      multipleSelection: [],
      multipleSelectionjson: null,
      // activeName:0,
      tabIndex: 0
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {
    timechange (e) {
      this.filterSelect();
    },

    changeType (value) {
      console.log(value);
      this.queryInfo.tid = value
      this.queryInfo.pagenum = 1
      this.getOrderList(); // 通过接口获取数据的方法
    },

    search () {
      this.orderlist = [];
      this.total = 0;
      this.queryInfo.pagenum = 1
      this.getOrderList(); // 通过接口获取数据的方法
    },

    handleFilterChange (filters) {
      console.log(filters);
      if (filters.type.length > 0) {

        this.queryInfo.tid = filters.type[0]
        if (this.queryInfo.tid == 1) {
          this.typeTxt = "常温商品"
        } else if (this.queryInfo.tid == 2) {
          this.typeTxt = "低温商品"
        } else {
          this.typeTxt = "商品类型"
        }
      } else {
        this.queryInfo.tid = 0;
        this.typeTxt = "商品类型"
        console.log(this.queryInfo);
      }
      this.getOrderList(); // 通过接口获取数据的方法
    },

    handleClick (tab, event) {
      console.log(tab);
      this.tabIndex = tab.index;
      this.queryInfo.status = this.tabIndex == 5 ? 6 : this.tabIndex
      this.filterSelect();
    },

    // 编辑
    editOrder (id) {
      console.log(id);
      this.$router.push({ path: '/orders/detail', query: { id: id } })
    },

    // 删除
    async deleteOrder (id) {
      const confirmResult = await this.$confirm(
        '订单删除后将不可找回,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delete', {
        id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('删除订单失败！')
      }
      this.$message.success('删除订单成功！')
      this.getOrderList()
    },

    filterSelect () {
      this.total = 0
      this.queryInfo.pagenum = 1;
      this.orderlist = []
      this.getOrderList()
    },
    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      console.log(list)
      if (list.length > 0) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsznttghpt.hsxsn.cn/exportHistoryOrderExcel?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsznttghpt.hsxsn.cn/exportHistoryOrderExcel?mPhone=' + localStorage.getItem('phone')
      }
    },

    // 批量确认订单 确认1 ,发货2,已完成3, 取消6
    async sureOrder1 () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将确认所有已选中的待确认订单，其余订单确认无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 1,
      })
      if (res.code !== 200) {
        return this.$message.error('确认订单失败！')
      }
      this.$message.success('确认订单成功！')
      this.getOrderList()
    },

    //点击确认定点杆
    clickSureOrder (id) {
      this.selectOrderId = id;
      this.sureOrderDialogVisible = true;
    },

    // 确认订单 确认1 ,发货2,已完成3, 取消6
    async sureOrder () {

      const { data: res } = await this.$http.post('admin/order/sureOrdersStatus', {
        id: this.selectOrderId,
        buType: this.buTypeForm.buType
      })
      if (res.code !== 200) {
        return this.$message.error('确认订单失败！')
      }
      this.$message.success('确认订单成功！')
      this.getOrderList()
      this.sureOrderDialogVisible = false;
    },

    sendOrder (id) {
      this.sendOrderId = id
      this.sendVisible = true
    },

    sendDialogClosed () {
      this.$refs.sendFormRef.resetFields()
    },

    sureOrderDialogClosed () {
      // this.$refs.sendFormRef.resetFields()
    },

    // 发货订单
    async sendVisibleSure () {
      this.$refs.sendFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/order/sendOrdersById', {
          order_id: this.sendOrderId,
          sendName: this.sendForm.sendName,
          sendPhone: this.sendForm.sendPhone,
        })
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        this.$message.success('订单发货成功！')
        this.sendVisible = false
        this.getOrderList()
      })
    },

    // 批量发货订单
    async sendOrder1 () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将发货所有已选中的已确认订单，其余订单发货无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 2,
      })
      if (res.code !== 200) {
        return this.$message.error('订单发货失败！')
      }
      this.$message.success('订单发货成功！')
      this.getOrderList()
    },

    // 批量完成订单
    async completeOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将所有已选中的已发货订单，其余订单完成无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 3,
      })
      if (res.code !== 200) {
        return this.$message.error('订单已完成操作失败！')
      }
      this.$message.success('订单已完成操作成功！')
      this.getOrderList()
    },

    // 批量取消订单
    async cancelOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '只能取消待支付和待确认的订单，其余订单取消无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 6,
      })
      if (res.code !== 200) {
        return this.$message.error('订单取消操作失败！')
      }
      this.$message.success('订单取消操作成功！')
      this.getOrderList()
    },

    async getOrderList () {
      const { data: res } = await this.$http.post('admin/order/getHistoryOrderList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('暂无历史订单！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    exportOrder () {
      console.log('11111');
      this.getOrderList()
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-select {
  width: 135px;
}

.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}

.daochuA {
  width: 60px;
  height: 24px;
  line-height: 24px;
  align-items: center;
  background-color: blue;
  color: #fff;
  align-content: center;
  margin-left: 20px;
  display: inline-block;
  padding: 20rpx;
  font-size: 14px;
  text-decoration: none;
}
</style>
